var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7773_5236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.49994C16 7.52138 15.824 6.58398 15.5024 5.71735L8 5.36951L0.497594 5.71732C0.176031 6.58398 0 7.52138 0 8.49994C0 9.47851 0.176031 10.4159 0.497594 11.2825L8 11.6304L15.5024 11.2826C15.824 10.4159 16 9.47851 16 8.49994Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 16.5C11.4397 16.5 14.372 14.329 15.5024 11.2826H0.497559C1.6279 14.329 4.56025 16.5 7.99996 16.5Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.497559 5.71741H15.5024C14.372 2.671 11.4397 0.5 7.99996 0.5C4.56025 0.5 1.6279 2.671 0.497559 5.71741Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7773_5236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmenia);
export default __webpack_public_path__ + "static/media/Armenia.435e6685aef235b700de1fd2221dd28d.svg";
export { ForwardRef as ReactComponent };